// extracted by mini-css-extract-plugin
export default {"changeDisclaimer":"jK-z","cltLink":"kK-z","shippingDisclaimer":"lK-z"};